export const DuplicateCycleStatus = [
    { label: 'None', value: 0, background: 'secondary' },
    { label: 'Started', value: 1, background: 'success' },
    { label: 'Opened', value: 2, background: 'info' },
    { label: 'Closed', value: 3, background: 'warning' },
    { label: 'Ranked', value: 4, background: 'info' },
    { label: 'Archived', value: 5, background: 'success' },
    { label: 'Disabled', value: 6, background: 'secondary' }
];
